if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("./service-worker.js")
      .then(function(reg) {
        // reg.onupdatefound = function() {
        //   var installingWorker = reg.installing;
        //   installingWorker.onstatechange = function() {
        //     switch (installingWorker.state) {
        //       case "installed":
        //         if (navigator.serviceWorker.controller) {
        //           var toast = document.getElementById("toast");
        //           toast.innerHTML =
        //             "A newer version is available. Tap to refresh.";
        //           toast.classList.add("show", "clickable");
        //           toast.onclick = function() {
        //             window.location.reload();
        //           };
        //         } else {
        //           // console.log('Content is now available offline!');
        //         }
        //         break;
        //       case "redundant":
        //         // console.error('The installing service worker became redundant.');
        //         break;
        //     }
        //   };
        // };
      })
      .catch(function(err) {
        console.error(err);
      });
  });
}



//////////////////
// WEBPACK FOOTER
// ./src/js/production.js
// module id = 4+nx
// module chunks = 0